var __jsx = React.createElement;
import { Button, Dialog } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Style from './CoverOverrideDialog.style';

var CoverOverrideDialog = function CoverOverrideDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onConfirmCover = _ref.onConfirmCover,
      onConfirmAll = _ref.onConfirmAll;
  return __jsx(Dialog, {
    open: open,
    onClose: onClose
  }, __jsx(Style.CloseButton, {
    onClick: onClose,
    "data-testid": "modal-override-cover-close-button"
  }), __jsx(FormattedMessage, {
    id: "cover-override-modal.title",
    tagName: Style.Title
  }), __jsx(FormattedMessage, {
    id: "cover-override-modal.content",
    tagName: Style.ContentText
  }), __jsx(Style.ButtonsContainer, null, __jsx(Button, {
    color: "primary",
    variant: "outlined",
    onClick: onConfirmCover
  }, __jsx(FormattedMessage, {
    id: "cover-override-modal.defaultOnly"
  })), __jsx(Button, {
    color: "primary",
    variant: "outlined",
    onClick: onConfirmAll
  }, __jsx(FormattedMessage, {
    id: "cover-override-modal.allFormats"
  }))));
};

export default CoverOverrideDialog;